import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import { X, Truck, MapPin, Users, Euro, CheckCircle2, FileText } from "lucide-react";

// Panneau d'information lecture seule pour une mission affichée dans le calendrier.
// Volontairement non éditable ici : l'édition complète se fait depuis la page Missions.
const MissionInfoModal = ({ mission, onClose, onDownloadWaybill }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={!!mission}
      onRequestClose={onClose}
      className="w-[95vw] max-w-md rounded-2xl p-0 shadow-2xl mx-auto relative animate-fade-in bg-base-100 border border-base-200"
      overlayClassName="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      ariaHideApp={false}
    >
      {mission && (
        <>
          <div className="flex items-center justify-between px-6 py-4 border-b border-base-200">
            <h2 className="text-lg font-bold text-base-content flex items-center gap-2">
              <Truck size={18} className="text-primary" /> {mission.client}
            </h2>
            <button onClick={onClose} className="btn btn-ghost btn-sm btn-square text-base-content/40">
              <X size={18} />
            </button>
          </div>

          <div className="p-6 space-y-4">
            {(mission.departure || mission.arrival) && (
              <div className="flex items-start gap-2.5">
                <MapPin size={15} className="text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-base-content/40 uppercase">{t("calendar.missionRoute", "Trajet")}</p>
                  <p className="text-sm font-semibold text-base-content">
                    {mission.departure || "?"} → {mission.arrival || "?"}
                  </p>
                </div>
              </div>
            )}

            {mission.address && (
              <div className="flex items-start gap-2.5">
                <MapPin size={15} className="text-base-content/30 mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-base-content/40 uppercase">{t("calendar.missionAddress", "Adresse")}</p>
                  <p className="text-sm text-base-content">{mission.address}</p>
                </div>
              </div>
            )}

            {mission.employees?.length > 0 && (
              <div className="flex items-start gap-2.5">
                <Users size={15} className="text-base-content/30 mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-base-content/40 uppercase">{t("mission.employees", "Employés")}</p>
                  <p className="text-sm text-base-content">{mission.employees.join(", ")}</p>
                </div>
              </div>
            )}

            {mission.priceTTC != null && (
              <div className="flex items-start gap-2.5">
                <Euro size={15} className="text-base-content/30 mt-0.5 shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-base-content/40 uppercase">{t("mission.priceTTC", "Prix TTC")}</p>
                  <p className="text-sm font-bold text-base-content">
                    {Number(mission.priceTTC || 0).toLocaleString("fr-FR")} €
                  </p>
                </div>
              </div>
            )}

            {mission.waybillSentAt && (
              <div className="flex items-center gap-2 rounded-lg bg-emerald-500/10 border border-emerald-500/20 px-3 py-2 text-emerald-600 text-sm font-medium">
                <CheckCircle2 size={14} /> {t("mission.list.waybillSentBadge", "LDV envoyée")}
              </div>
            )}
          </div>

          <div className="px-6 py-4 border-t border-base-200 flex justify-between gap-2">
            <button
              onClick={() => onDownloadWaybill(mission.rawId)}
              className="btn btn-primary btn-sm flex items-center gap-1"
            >
              <FileText size={15} /> {t("mission.list.waybill")}
            </button>
            <button onClick={onClose} className="btn btn-ghost btn-sm">
              {t("calendar.close", "Fermer")}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default MissionInfoModal;
